import { useState, useCallback, useContext } from "react";
import { useFormik } from "formik";
import { handleSubmitFaceImage, handleConfirmRecorder_v1 } from "api/timeRecorder";
import useToastNotification from "hooks/useToastNotification";
import ConfirmRecorderByFaceDomain from "domain/timeRecorder/confirmRecorderByFaceDomain";

import StampHistoryListRecorderDomain from "domain/timeRecorder/stampHistoryListRecorderDomain";
import { CurrentTimeDomain } from "domain/master/attend/currentTime";
import { TimeRecorderContext } from "components/organismos/RecorderV1/RecorderV1";

const { errorNotification, successNotification } = useToastNotification();

export const useFaceRecorder = (
  resultCurrentTime: CurrentTimeDomain,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  fetchHistoryData: any,
) => {
  // Mode Id recorder
  const stampMode = 1;

  // Load Context Global Variable Recorder
  const contextObject = useContext(TimeRecorderContext);

  const historyListRecorderInit = StampHistoryListRecorderDomain.generateInitial();
  const [stampHistoryList, setStampHistoryList] = useState<Array<StampHistoryListRecorderDomain>>([
    historyListRecorderInit,
  ]);
  const [isConfirm, setIsConfirm] = useState(false);

  const [lastStampType, setLastStampType] = useState<number>();

  // Image
  const [tmpFilePath, setTmpFilePath] = useState("");
  const [stampStaffList, setStampStaffList] = useState<any>();
  const [useRecess, setUseRecess] = useState(true);
  const [faceId, setFaceId] = useState("");
  const [mistake, setMistake] = useState<any>("");
  const [similarity, setSimilarity] = useState("");
  const [photoFullpath, setPhotoFullpath] = useState("");
  const [currentStaffIdx, setCurrentStaffIdx] = useState(0);

  //Use New UI Remote
  const [newUiRemote, setNewUiRemote] = useState<boolean>(false);
  const [isRemote, setIsRemote] = useState<boolean>(false);

  const [staffName, setStaffName] = useState("");
  const [staffCode, setStaffCode] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [orgName, setOrgName] = useState("");

  const handleSubmitFace = async (file: any) => {
    setIsLoading(true);
    let formDataImage: any = {
      orgCode: contextObject.loginOrgCode,
      orgName: contextObject.loginOrgName,
      loginOrgCode: contextObject.loginOrgCode,
      loginOrgName: contextObject.loginOrgName,
      tmpFilePath,
      staffName: contextObject.staffName,
      faceId,
      mistake,
      stampMode,
      stampByBelongOrg: contextObject.stampByBelongOrg,
      similarity,
      stampTime: String(resultCurrentTime.serverDateTime),
      photo: file,
    };
    try {
      await handleSubmitFaceImage("", contextObject.companyCode, formDataImage).then((response: any) => {
        if (!response.errors) {
          setTmpFilePath(response.tmpFilePath);
          setStampStaffList(response.stampStaffList);
          const stampStaffData = response.stampStaffList[0];
          // eslint-disable-next-line no-shadow
          setStaffName(stampStaffData.staffName);
          setStaffCode(stampStaffData.staffCode);
          setOrgCode(stampStaffData.orgCode);
          setOrgName(stampStaffData.orgName);

          setLastStampType(stampStaffData.lastStampType);
          setFaceId(stampStaffData.faceId);
          setUseRecess(stampStaffData.useRecess);
          setCurrentStaffIdx(currentStaffIdx);
          setSimilarity(stampStaffData.similarity);
          setMistake(response.mistake);
          setPhotoFullpath(stampStaffData.photoFullpath);
          setStaffName(stampStaffData.staffName);
          setNewUiRemote(stampStaffData.useRemote);
          setIsRemote(stampStaffData.isRemote);
          contextObject.setRemote(stampStaffData.useRemote);
          setIsConfirm(true);
        }
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.data && error.response.data.message) {
        const err = error.response.data.message.replace(/<br>/gi, "\n");
        errorNotification(err);
      } else {
        errorNotification("サーバー側でエラーが発生しました。");
        throw error;
      }
    }
  };

  // Recorder

  const onSubmitConfirmFace = async (values: ConfirmRecorderByFaceDomain) => {
    setIsLoading(true);
    handleConfirmRecorder_v1(contextObject.companyCode, values.getRawData())
      .then((response: any) => {
        setCurrentStaffIdx(0);
        successNotification(response.stampResultInfo.replace("<h4>", "").replace("</h4>", ""));
        setStaffName("");
        fetchHistoryData();
        formik.resetForm();
        setIsConfirm(false);
        setIsLoading(false);
        contextObject.setRemote(false);
      })
      .catch((error: any) => {
        setStaffName("");
        setCurrentStaffIdx(0);
        setIsLoading(false);
        contextObject.setRemote(false);
        if (error.response.status === 400) {
          if (error.response.data.errors && error.response.data.errors.length > 0) {
            errorNotification(error.response.data.errors.map((x: any) => x.defaultMessage));
          } else if (error.response.data.defaultMessage) {
            errorNotification(error.response.data.defaultMessage);
          } else {
            errorNotification(error.response.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }
      });
  };

  const formik = useFormik({
    initialValues: ConfirmRecorderByFaceDomain.generateInitial(),
    onSubmit: (values) => {
      onSubmitConfirmFace(values);
    },
  });

  const handleRecorder = useCallback(
    (stampType: number, businessId?: string, flagRemote?: boolean) => {
      if (flagRemote) {
        formik.setFieldValue("isRemote", true);
      } else {
        formik.setFieldValue("isRemote", isRemote);
      }
      formik.setFieldValue("companyCode", contextObject.companyCode);
      formik.setFieldValue("staffCode", staffCode);
      formik.setFieldValue("stampMode", stampMode);
      formik.setFieldValue("stampType", stampType);
      formik.setFieldValue("orgCode", orgCode);
      formik.setFieldValue("orgName", orgName);
      formik.setFieldValue("loginOrgName", orgName);
      formik.setFieldValue("loginOrgCode", orgCode);
      formik.setFieldValue("staffName", staffName);
      formik.setFieldValue("faceId", faceId);
      formik.setFieldValue("tmpFilePath", tmpFilePath);
      formik.setFieldValue("similarity", similarity);
      formik.setFieldValue("mistake", mistake);
      formik.setFieldValue("stampTime", String(contextObject.resultCurrentTime.serverDateTime));
      formik.submitForm();
    },
    [
      isRemote,
      faceId,
      formik,
      mistake,
      similarity,
      tmpFilePath,
      contextObject,
      orgCode,
      orgName,
      staffCode,
      staffName,
    ],
  );

  const handleMistake = () => {
    const nextStaffIdx = currentStaffIdx + 1;
    if (nextStaffIdx >= stampStaffList.length) {
      setCurrentStaffIdx(0);
      errorNotification(
        "類似するスタッフが存在しませんでした。<br>スタッフ設定画面にて顔写真を更新してから打刻を行ってください。",
      );
      setIsConfirm(false);
      setPhotoFullpath("");
      formik.resetForm();
      setStaffName("");
    } else {
      const stampData = stampStaffList[nextStaffIdx];
      setLastStampType(stampData.lastStampType);
      setUseRecess(stampData.useRecess);
      setStaffName(stampData.staffName);
      setStaffCode(stampData.staffCode);
      setOrgCode(stampData.orgCode);
      setOrgName(stampData.orgName);
      setNewUiRemote(stampData.useRemote);
      setIsRemote(stampData.isRemote);
      contextObject.setRemote(stampData.useRemote);
      setFaceId(stampData.faceId);
      setPhotoFullpath(stampData.photoFullpath);
      setCurrentStaffIdx(nextStaffIdx);
      setMistake(true);
      setSimilarity(stampData.similarity);
    }
  };
  return {
    stampHistoryList,
    isConfirm,
    lastStampType,
    setLastStampType,
    stampMode,
    photoFullpath,
    useRecess,
    formik,
    tmpFilePath,
    faceId,
    similarity,
    mistake,
    handleMistake,
    setIsConfirm,
    setStampHistoryList,
    errorNotification,
    setPhotoFullpath,
    handleSubmitFace,
    handleRecorder,
    contextObject,
    staffName,
    orgName,
    newUiRemote,
  };
};
export default useFaceRecorder;
